import { useCallback, useState } from "react"

import { settingsService } from "services/settings/settings.service"

import { ConnectionState } from "./types"

export interface UseConnectionStatusResult {
  status: ConnectionState
  testing: boolean
  runTest: () => Promise<void>
}

export function useConnectionStatus(): UseConnectionStatusResult {
  const [status, setStatus] = useState<ConnectionState>(null)
  const [testing, setTesting] = useState(false)

  const runTest = useCallback(async () => {
    setTesting(true)
    setStatus("loading")
    const result = await settingsService.testCioConnection()
    setStatus(result)
    setTesting(false)
  }, [])

  return { status, testing, runTest }
}
